import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { CompanyFilterData } from '@/services/optionGroups';
import { FilterDropDown } from '@ygtechnologies/bygr-frontend-component-library';

interface CompanyFilterProps {
    value?: number[];
    onChange: (value: number[]) => void;
    companies?: CompanyFilterData[];
}

export const CompanyFilter: React.FC<CompanyFilterProps> = ({ value = [], onChange, companies = [] }) => {
    return (
        <FilterDropDown
            placeholder={t`Any company`}
            label={<Trans>Company</Trans>}
            data={companies.map((company) => ({
                id: company.id,
                name: company.name,
            }))}
            value={value}
            onChange={(v) => onChange(v.map((x) => x.id))}
        />
    );
};